
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile/notifications",
      function () {
        return require("private-next-pages/profile/notifications.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile/notifications"])
      });
    }
  